import { createServerFn } from '@tanstack/react-start';
import { getRequest } from '@tanstack/react-start/server';
import { z } from 'zod';

import { getInstrumentByTicker } from '~/database/supabase/instrument_company/queries.server.ts';
import { addUserSearch } from '~/database/supabase/user_search/queries.server.ts';

import { requireStartAuthSession } from '../auth/require-start-auth-session.ts';
import { createServerFnObservabilityMiddleware } from '../utils/create-instrumented-server-fn.ts';

const AddNavbarUserSearchSchema = z.object({
	ticker: z.string().trim().min(1).max(30),
});

export const addNavbarUserSearch = createServerFn({ method: 'POST' })
	.middleware([
		createServerFnObservabilityMiddleware({
			dependencies: ['auth.session', 'supabase.instrument.lookup', 'supabase.user-search.write'],
			relatesTo: 'app.navbar-user-search',
		}),
	])
	.inputValidator(AddNavbarUserSearchSchema)
	.handler(async ({ data }) => {
		const request = getRequest();
		const authSession = await requireStartAuthSession({
			onFailRedirectTo: '/auth/signin',
			request,
			verify: false,
		});

		const instrument = await getInstrumentByTicker({
			ticker: data.ticker,
		});

		if (!instrument) {
			return null;
		}

		return addUserSearch({
			instrumentId: instrument.id,
			userId: authSession.userId,
		});
	});
